module.exports = __webpack_public_path__ + "img/sezzle_logo.61f14fdb.svg";